import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=f7a4fefe&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a4fefe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7a4fefe')) {
      api.createRecord('f7a4fefe', component.options)
    } else {
      api.reload('f7a4fefe', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=f7a4fefe&scoped=true&", function () {
      api.rerender('f7a4fefe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2go3VxX00tbNj/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports